module.exports = __webpack_public_path__ + "img/FTHS__FantasyHammer_2.47485c9f.png";